<template>
    <v-dialog v-model="dialogDelete" :max-width="maxWidth">
        <v-card>
            <v-card-title class="text-h5" v-html="title"></v-card-title>
            <v-card-text v-html="text"></v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="onOk">OK</v-btn>
                <v-btn color="blue darken-1" text @click="onClose">Отмена</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DialogConfirm",
    props:{
        maxWidth: {
            type: String,
            default: "500px"
        },
        title: {
            type: String,
            default: ""
        },
        text: {
            type: String,
            default: ""
        },
        closeAfterAction: {
            type: Boolean,
            default: true
        }
    },
    data(){
        return {
            dialogDelete: false,
        }
    },
    watch: {
        dialogDelete: function (nVal) {
            if(true === nVal){
                this.$emit('open');
            }else {
                this.$emit('close');
            }
        }
    },
    methods: {
        onClose(){
            this.close();
        },
        onOk(){
            this.$emit('confirm');
            if(this.closeAfterAction){
                this.close();
            }
        },
        close(){
            this.dialogDelete = false;
        },
        show(){
            this.dialogDelete = true;
        }
    },
}
</script>

<style scoped>

</style>